define(['jquery', usagetrack], function ($, usagetrack) {
  "use strict";

  let self;

  function process() {
    //console.log('Processing click-to-call event.....');
    window.usagetrack.addFilter(function(sEvent, jEl, aParents) {
      if (jEl.data('ctc-track')) {
        let aData = jEl.data('ctc-track');
        let eventAction = aData[0];

        if (eventAction) {
          // Parse the action if it is in the format "office-ODP-CTC" and get the source page "ODP".
          let actionParts = eventAction.split('-');

          // If the action is not in the correct format, return true
          if (actionParts.length < 2) {
            return true;
          }

          // Set the source page based on the action
          let sourcePage = actionParts[1];

          // Set the source form type based on the source page
          let sourceFormType = null;
          if (sourcePage !== '') {
            switch (sourcePage) {
              case 'PDP':
                sourceFormType = 'property-detail';
                break;
              case 'PRP':
                sourceFormType = 'property-search';
                break;
              case 'FTS':
                sourceFormType = 'free-search';
                break;
              case 'header':
                sourceFormType = 'site-header';
                break;
              case 'footer':
                sourceFormType = 'site-footer';
                break;
              case 'roster':
                sourceFormType = 'agent-roster';
                break;
              case 'locations':
                sourceFormType = 'office-locations';
                break;
            }

            if(sourceFormType == null) {
              if (eventAction === 'legal-contact-CTC') {
                sourceFormType = 'legal';
              } else if (eventAction.indexOf('contact-us') !== -1) {
                sourceFormType = 'contact-us';
              } else if (eventAction.indexOf('ask-question') !== -1 ||
                eventAction.indexOf('see-listing') !== -1 ||
                eventAction.indexOf('request-price') !== -1) {
                sourceFormType = 'property-detail';
              }
            }

            // Push the event to the data layer with the source form type if it is available
            if (sourceFormType !== null) {
              //console.log('Pushing click-to-call event to data layer with source form type: ' + sourceFormType);
              window.dataLayer.push({
                'event': 'click-to-call',
                'sourceFormType': sourceFormType,
                'sourceUrl': window.location.href,
              });
            }
          }
        }

        return true;
      }
    });
  }

  self = {
    process: process
  }

  window.ctctrack = self;

  return self;
});
